module.exports = __webpack_public_path__ + "images/emoji/headphones.9eeb00b051de5e2f3061.png";